import { OperatorFilter, TermFilter } from '@dofleini/query-builder';
import { useMemo } from 'react';
import { useQuery } from 'react-query';

import {
  CACHE_KEY_LIST_PROTECTED_AREA_COUNT,
  CACHE_KEY_PROTECTED_AREA
} from '@/modules/configuration/contants/protectedArea';
import { fields } from '@/modules/configuration/contants/protectedArea.form';
import ProtectedAreaApiService from '@/modules/configuration/services/ProtectedAreaApiService';
import { createFieldsHook } from '@/utils/createFieldsHook';
import { createGetOneHook } from '@/utils/createGetOneHook';

export const useGetOneProtectedArea = createGetOneHook(ProtectedAreaApiService, 'id', CACHE_KEY_PROTECTED_AREA);
export const useFields = createFieldsHook('protectedArea', fields);

export const useCountProtectedAreasByProvince = (location) => {
  const filters = useMemo(() => new OperatorFilter({
    type: 'AND', filters: [
      new TermFilter({ field: 'address.province', value: location?.province }),
      new TermFilter({ field: 'municipalities', value: location?.municipality })
    ]
  }).toQuery(), [location?.municipality, location?.province]);
  
  return useQuery([CACHE_KEY_LIST_PROTECTED_AREA_COUNT, location?.province, location?.municipality], async () => {
    const { data } = await ProtectedAreaApiService.count({ filters });
    return data;
  }, {
    enabled: !!location?.province && !!location?.municipality,
    refetchOnWindowFocus: false
  });
};
